<template>
  <div class="accordion h-auto p-3">
    <div class="w-full">
      <h1 class="text-2xl text-gray-900 font-medium dark:text-gray-200">Config Management</h1>
      <div class="flex-top" style="display: flex">
        <div style="width: 50%; float: left">
          <p class="mt-1 text-sm font-normal text-gray-400">Manage configurations with name and delay settings</p>
        </div>
        <div class="demo-dropdown-wrap" style="margin-left: auto"></div>
      </div>
    </div>
    <div class="grid lg:grid-cols-1 grid-col-1 gap-4 mt-5">
      <div class="
          card
          col-span-1
          grid grid-cols-1
          gap-5
          bg-white
          dark:bg-gray-800
          w-full
          rounded-md
          p-5
          shadow
        ">
        <div class="accordion-packed">
          <h2 v-if="!edit" style="display: flex" class="font-semibold dark:text-gray-200">
            <a-input v-if="activeKey != '0'" v-model:value="selectedConfigname" placeholder="Config Name" style="margin-right: 10px;" />
            <a-input-number v-if="activeKey != '0'" v-model:value="delayValue" placeholder="Delay (s)" :min="0" :step="0.1" :precision="2" style="margin-right: 10px; width: 150px;" />
            <a-button v-if="activeKey != '0'" type="text" @click="saveData">Save</a-button>
            <label style="
                margin-left: auto;
                display: flex;
                justify-content: flex-end;
                align-items: center;
              " class="switch">
            </label>
          </h2>

          <a-tabs v-model:activeKey="activeKey">
            <a-tab-pane key="0" tab="Saved Configs">
              <a-list v-if="selectedConfigLocal != null" class="demo-loadmore-list" item-layout="horizontal"
                :data-source="selectedConfigLocal">
                <template #renderItem="{ item }">
                  <a-list-item>
                    <template #actions>
                      <a @click="setConfig(item)">Load</a>
                      <a-popconfirm title="Do you wish to delete this Config entry?" ok-text="Yes" okType="default" cancel-text="No"
                        @confirm="deleteConfig(item)">
                        <a>Delete</a>
                      </a-popconfirm>
                    </template>
                    <a-list-item-meta>
                      <template #description>
  <a>Delay: {{ item.config.delay }}s | Last modified: {{ new Date(item.createdAt).toLocaleString() }} by {{ item.username }}</a>
</template>
                      <template #title>
                        <a>{{ item.broadcastName }}</a>
                      </template>
                      <template #avatar>
                        <ProfileOutlined />
                      </template>
                    </a-list-item-meta>
                  </a-list-item>
                </template>
              </a-list>
            </a-tab-pane>
            <a-tab-pane key="1" tab="Create Config">
              <div class="mt-5">
                <p class="text-gray-500 dark:text-gray-400">Enter a config name and delay value above, then click Save.</p>
              </div>
            </a-tab-pane>
          </a-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { ProfileOutlined } from "@ant-design/icons-vue";
import store from "../store/index.js";
import { message } from 'ant-design-vue';
import {
  getNewConfig, pushNewConfig, removeNewConfig
} from "../graphql/graphqlActions";

const edit = ref(false);
var activeKey = ref("0");
var selectedConfigLocal = ref([]);
var selectedConfigname = ref(null);
var delayValue = ref(0);
var loadedConfigId = ref(null); // Track the loaded config's ID

onMounted(async () => {
  await configRetrieve()
})

async function configRetrieve() {
  let configlist = await getNewConfig(store.state.user.organisation, null, null);
  let parsed = JSON.parse(configlist.getNewConfig);
  selectedConfigLocal.value = parsed.items.map(item => ({
    ...item,
    config: JSON.parse(item.config)
  }));
}

function setConfig(item) {
  selectedConfigname.value = item.broadcastName;
  delayValue.value = item.config.delay;
  loadedConfigId.value = item.id; // Store the ID for deletion on save
  activeKey.value = "1";
}

async function deleteConfig(item) {
  message.loading('Deleting Configuration');
  await removeNewConfig(item.id);
  await configRetrieve();
  message.success('Successfully Deleted Configuration: ' + item.broadcastName);
}

async function saveData() {
  if (selectedConfigname.value == null || selectedConfigname.value == '') {
    message.error('A name must be set for this configuration');
    return;
  }
  if (delayValue.value == null) {
    message.error('A delay value must be set');
    return;
  }
  
  message.loading('Saving Configuration');

  // If editing an existing config, delete the old one first
  if (loadedConfigId.value != null) {
    await removeNewConfig(loadedConfigId.value);
  }
  
  var details = { "delay": delayValue.value };
  await pushNewConfig(
    selectedConfigname.value, 
    JSON.stringify(details), 
    store.state.user.organisation,
    store.state.user.screenName || store.state.user.name
  );
  await configRetrieve();
  message.success('Configuration saved: ' + selectedConfigname.value);
  
  // Reset form
  selectedConfigname.value = null;
  delayValue.value = 0;
  loadedConfigId.value = null;
  activeKey.value = "0";
}
</script>

<style scoped>
.demo-loadmore-list {
  min-height: 350px;
}
</style>